import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber Meta Ads?',
  a: 'No. La guía está pensada para que puedas empezar desde cero y entender qué hacer paso a paso.'
}, {
  q: '¿Me sirve si recién estoy empezando a vender iPhones?',
  a: 'Sí. De hecho, te va a ayudar a ordenar mejor qué modelos ofrecer, cómo crear anuncios y cómo evitar errores comunes desde el inicio.'
}, {
  q: '¿Me sirve si ya tengo una tienda?',
  a: 'Sí. Especialmente si ya vendés pero querés mejorar la calidad de las consultas y dejar de depender solo del contenido orgánico o de agencias.'
}, {
  q: '¿La guía es en PDF?',
  a: 'Sí. Es una guía práctica en PDF que podés leer a tu ritmo y volver a consultar cuando quieras.'
}, {
  q: '¿Incluye plantillas?',
  a: 'Sí. Incluye plantillas, checklist y ejemplos para adaptar a tu tienda.'
}, {
  q: '¿Necesito mucho presupuesto para hacer anuncios?',
  a: 'No necesitás empezar con presupuestos enormes. La guía te enseña a pensar campañas simples y ordenadas para validar qué anuncios funcionan.'
}, {
  q: '¿Es solo para Argentina?',
  a: 'El contenido está pensado principalmente para tiendas de habla hispana. Muchas estrategias aplican a Argentina y también a otros mercados donde se venden iPhones por Instagram.'
}, {
  q: '¿Esto reemplaza una agencia?',
  a: 'El objetivo es que entiendas cómo funciona la publicidad para tu negocio y puedas tomar mejores decisiones, ya sea que ejecutes vos o que después delegues con más criterio.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-32 bg-zinc-50" data-id="element-62">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-63">
        <div className="text-center mb-12" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900" data-id="element-65">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-zinc-200 rounded-2xl overflow-hidden" data-id="element-67">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-68">
                <span className="font-semibold text-zinc-900 pr-8" data-id="element-69">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-zinc-500 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" />
              </button>
              <AnimatePresence data-id="element-71">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-72">
                    <div className="px-6 pb-6 text-zinc-600 leading-relaxed" data-id="element-73">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}